import React, { createContext, useState, useEffect } from "react"
import UserTableTitle from "../../constants/UserTableTitle.json"
import { db } from "../../helpers/firebase_helper"

export const AdminContext = createContext()

export const AdminContextProvider = ({ children }) => {
  const [adminData, setAdminData] = useState([""])
  const [totalPagesCount, setTotalPagesCount] = useState(0)
  const [userDataBackup, setUserDataBackup] = useState()
  const [pageNumberThreshold, setPageNumberThreshold] = useState(0)

  /**
   * Get admin list from db
   */
  const getAdminList = async () => {
    let fullUserList = []

    const snapshot = await db.collection("users").get()
    snapshot.forEach(doc => {
      const snapshotDashboard = doc
      const userDoc = { ...snapshotDashboard.data(), id: doc.id }
      fullUserList.push(userDoc)
    })

    const fileteredData = fullUserList.filter(item => {
      if (item?.admin && !item.serviceProvider) return item
    })

    const totalPages = Math.ceil(fileteredData.length / 10)

    setPageNumberThreshold(0)
    setTotalPagesCount(totalPages)
    setUserDataBackup(fileteredData)
    setAdminData(fileteredData.slice(0, 10))
  }

  const nextPage = async currentPageNumber => {
    setPageNumberThreshold((currentPageNumber - 1) * 10)
    const startIndex = (currentPageNumber - 1) * 10
    const endIndex = currentPageNumber * 10
    const results = userDataBackup.slice(startIndex, endIndex)
    setAdminData(results)
  }
  useEffect(() => {
    getAdminList()
  }, [])

  const providerValue = {
    adminData,
    UserTableTitle,
    getAdminList,
    nextPage,
    totalPagesCount,
    pageNumberThreshold,
  }

  return (
    <AdminContext.Provider value={providerValue}>
      {children}
    </AdminContext.Provider>
  )
}
